<template>
  <button
      :title="title"
      :disabled="disabled"
      @click="handleClick"
      class="button transition-smooth flex-col align-items-center justify-content-center"
      :class="[btnType, disabled ? 'disabled' : '']"
      :style="btnStyle"
  >
    <slot name="icon">
      <i class="fallback-icon" :class="icon"></i>
    </slot>
  </button>
</template>

<script>
import BootstrapTypes from "../enums/BootstrapTypes";
import Spacings from "../enums/Spacings";

export default {
  name: "IconButton.vue",
  emits: ['click'],
  props: {
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    },
    title:{
      type: String,
      required: false,
      default: ''
    },
    size: {
      required: false,
      type: String,
      default: 'xxl',
      validator(value) {
        return Object.keys(Spacings).includes(value);
      }
    },
    icon: {
      type: String,
      required: false,
    },
    type: {
      validator(value) {
        return Object.values(BootstrapTypes).includes(value);
      },
      default() {
        return BootstrapTypes.primary;
      }
    },
    href: {
      type: String,
      required: false,
    }
  },
  computed: {
    btnType() {
      return `button-${this.type}`;
    },
    btnStyle(){
      return  {
        padding: 0,
        width: Spacings[this.size] + 'px !important',
        height: Spacings[this.size] + 'px !important',
        minHeight: Spacings[this.size] + 'px !important',
        minWidth: Spacings[this.size] + 'px !important',
        fontSize: ( Spacings[this.size] * 0.57 ) + 'px'
      };
    }
  },
  methods: {
    handleClick() {
      this.$emit('click');
      if ( this.href ){
        window.location.href = this.href;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/_default.scss';

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
}

.disabled {
  opacity: 0.5;
}
.animate-spin {
  animation: spin .8s ease-in-out infinite;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
}
</style>
